(function () {
  'use strict';

  angular.module('sempraWebapp').factory('webSocketsStore', webSocketsStoreFactory);

  /** @ngInject */
  function webSocketsStoreFactory (dispatcher, EventEmitter, ActionTypesEnum) {
    var WebSocketsStore = new EventEmitter(),
      /* eslint-disable */
      dataImmutable = Immutable.fromJS({
        connected: false
      });
      /* eslint-enable */
    WebSocketsStore.events = Object.freeze({
      CONNECTED_CHANGE: 'connected_change',
      DEVICE_FEED_CHANGE: 'device_feed_change',
      DEVICE_ACTUATOR_CHANGE: 'device_actuator_change',
      DEVICE_STATE_CHANGE: 'device_state_change',
      MESSAGES_UPDATE_AVAILABLE: 'messages_update_available',
      DAILY_FINANCES_CHANGE: 'daily_finances_change',
      NOTICE_CHANGE: 'notice_change',
      DEVICE_EVENT_CHANGE: 'device_event_change'
    });

    WebSocketsStore.isConnected = function () {
      return dataImmutable.toJSON().connected;
    };

    WebSocketsStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.CONNECTED_CHANGE:
          var data = dataImmutable.toJSON();
          data.connected = actionData.payload;
          /* eslint-disable */
          dataImmutable = Immutable.fromJS(data);
          /* eslint-enable */
          WebSocketsStore.emit(WebSocketsStore.events.CONNECTED_CHANGE, dataImmutable.get("connected"));
          break;
        case ActionTypesEnum.DEVICE_FEED_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DEVICE_FEED_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.DEVICE_ACTUATOR_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DEVICE_ACTUATOR_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.DEVICE_STATE_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DEVICE_STATE_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.MESSAGES_UPDATE_AVAILABLE:
          WebSocketsStore.emit(WebSocketsStore.events.MESSAGES_UPDATE_AVAILABLE, actionData.payload);
          break;
        case ActionTypesEnum.DAILY_FINANCES_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DAILY_FINANCES_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.NOTICE_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.NOTICE_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.DEVICE_EVENT_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DEVICE_EVENT_CHANGE, actionData.payload);
          break;
      }
    });

    return WebSocketsStore;
  }
})();
